export const GET_CITY_MENU = "GET_CITY_MENU";
export const GET_HOTELS_BY_LOCATION = "GET_HOTELS_BY_LOCATION";
export const GET_HOTELS_BY_ID = "GET_HOTELS_BY_ID";
export const GET_HOTELS_BY_CUSTOMER_OR_LOCATION = "GET_HOTELS_BY_CUSTOMER_OR_LOCATION";
export const GET_USER_DETAILS_BY_ID = "GET_USER_DETAILS_BY_ID";
export const GET_CUSTOMER_BOOKING_INFO = "GET_CUSTOMER_BOOKING_INFO";
